export default {
  URL_TOKEN: null,
  ACCESS_TOKEN: null,
  REFRESH_TOKEN: null,
};
